import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  SearchOutlined,
  BellOutlined,
  ShoppingOutlined,
  DashboardOutlined,
  UserOutlined,
  DownOutlined,
  CarOutlined,
  ClockCircleOutlined,
  FieldTimeOutlined,
  BankOutlined,
  HomeOutlined,
  GlobalOutlined,
  DollarOutlined,
  ClockCircleOutlined as TimeIcon,
  PhoneOutlined,
  TagOutlined,
  PlusOutlined,
  ShopOutlined,
  EnvironmentOutlined,
  CarOutlined as TransportIcon,
  SafetyOutlined,
  FileTextOutlined,
  UploadOutlined,
  GiftOutlined,
  CreditCardOutlined,
  TeamOutlined,
  ShopOutlined as FactoryIcon,
  EnvironmentOutlined as WarehouseIcon,
  CarOutlined as PortIcon,
  TruckOutlined,
  SafetyCertificateOutlined,
  FileTextOutlined as CertificateIcon,
  GiftOutlined as PackagingIcon,
  CreditCardOutlined as PaymentIcon,
  FileTextOutlined as RefundIcon
} from '@ant-design/icons';
import { Button, Avatar, Space } from 'antd';
import '../../assets/styles/theme.scss';
import '../../assets/styles/buyerSellerProfile.scss';

// styles moved to ../../../assets/styles/buyerSellerProfile.scss

const BuyerSellerProfile = () => {
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState('company');
  
    const businessTypeOptions = [
    'Manufacturer',
    'Trader', 
    'Distributor',
    'Retailer',
    'Wholesaler',
    'Service Provider',
    'Exporter',
    'Importer',
    'Agent',
    'Broker',
    'Other'
  ];

  const countryOptions = [
    'India',
    'United States',
    'United Kingdom',
    'Canada',
    'Australia',
    'Germany',
    'France',
    'Japan',
    'China',
    'Brazil',
    'Other'
  ];

  const currencyOptions = [
    'INR - Indian Rupee',
    'USD - US Dollar',
    'EUR - Euro',
    'GBP - British Pound',
    'CAD - Canadian Dollar',
    'AUD - Australian Dollar',
    'JPY - Japanese Yen',
    'CNY - Chinese Yuan',
    'Other'
  ];

  const stateOptions = [
    'Andhra Pradesh',
    'Arunachal Pradesh',
    'Assam',
    'Bihar',
    'Chhattisgarh',
    'Goa',
    'Gujarat',
    'Haryana',
    'Himachal Pradesh',
    'Jharkhand',
    'Karnataka',
    'Kerala',
    'Madhya Pradesh',
    'Maharashtra',
    'Manipur',
    'Meghalaya',
    'Mizoram',
    'Nagaland',
    'Odisha',
    'Punjab',
    'Rajasthan',
    'Sikkim',
    'Tamil Nadu',
    'Telangana',
    'Tripura',
    'Uttar Pradesh',
    'Uttarakhand',
    'West Bengal',
    'Other'
  ];

  const cityOptions = [
    'Mumbai',
    'Delhi',
    'Bangalore',
    'Hyderabad',
    'Ahmedabad',
    'Chennai',
    'Kolkata',
    'Pune',
    'Jaipur',
    'Lucknow',
    'Kanpur',
    'Nagpur',
    'Indore',
    'Thane',
    'Bhopal',
    'Visakhapatnam',
    'Pimpri-Chinchwad',
    'Patna',
    'Vadodara',
    'Ghaziabad',
    'Other'
  ];

  const shippingTermsOptions = [
    'FOB - Free On Board',
    'CIF - Cost, Insurance and Freight',
    'CFR - Cost and Freight',
    'EXW - Ex Works',
    'FCA - Free Carrier',
    'CPT - Carriage Paid To',
    'CIP - Carriage and Insurance Paid To',
    'DAP - Delivered At Place',
    'DPU - Delivered at Place Unloaded',
    'DDP - Delivered Duty Paid',
    'Other'
  ];

  const transportModeOptions = [
    'Road Transport',
    'Rail Transport',
    'Sea Freight',
    'Air Freight',
    'Multimodal Transport',
    'Express Delivery',
    'Courier Service',
    'Other'
  ];

  const packingTypeOptions = [
    'Standard Box',
    'Custom Box',
    'Pallet',
    'Crate',
    'Bag',
    'Bulk',
    'Individual',
    'Other'
  ];

  const packingMaterialsOptions = [
    'Cardboard',
    'Wood',
    'Plastic',
    'Metal',
    'Fabric',
    'Bubble Wrap',
    'Foam',
    'Other'
  ];

  const labellingOptions = [
    'Standard Label',
    'Custom Label',
    'Barcode',
    'QR Code',
    'Handwritten',
    'Printed',
    'Sticker',
    'Other'
  ];

  const paymentMethodOptions = [
    'Bank Transfer',
    'Credit Card',
    'PayPal',
    'Cash on Delivery',
    'Letter of Credit',
    'Cheque',
    'Cryptocurrency',
    'Other'
  ];

  const paymentScheduleOptions = [
    'Immediate Payment',
    'Net 15 Days',
    'Net 30 Days',
    'Net 45 Days',
    'Net 60 Days',
    'Net 90 Days',
    'Milestone Based',
    'Other'
  ];

  const latePaymentPolicyOptions = [
    'No Penalty',
    '1% per Month',
    '2% per Month',
    '5% per Month',
    'Fixed Penalty',
    'Interest Rate Based',
    'Other'
  ];
  
  
  const tabs = [
    { key: 'company', label: 'Company Details', icon: <UserOutlined /> },
    { key: 'factory', label: 'Factory Details', icon: <CarOutlined /> },
    { key: 'quality', label: 'Quality Control', icon: <DashboardOutlined /> },
    { key: 'product', label: 'Product Catalogue', icon: <ShoppingOutlined /> },
    { key: 'packaging', label: 'Packaging Details', icon: <BellOutlined /> }
  ];
  const [formData, setFormData] = useState({
    // Company Details
    companyName: '',
    designation: '',
    businessType: '',
    gstNumber: '',
    registrationNumber: '',
    website: '',
    noOfEmployees: '',
    yearEstablished: '',
    companyDescription: '',
    mainProducts: [],
    mainProductInput: '',
    
    // Address
    address: '',
    landmark: '',
    countryRegion: '',
    city: '',
    state: '',
    pincode: '',
    currency: '',
    
    // Bank Details
    accountHolder: '',
    accountNumber: '',
    bankName: '',
    branchName: '',
    ifscCode: '',
    swiftCode: '',
    
    // Trading Information
    totalRevenue: '',
    exportPercentage: '',
    overseasAddress: '',
    iecNumber: '',
    
    // Timezone
    timezone: '',
    
    // Contact Details
    alternateContactName: '',
    alternateEmail: '',
    alternateContact: '',
    
    // File uploads
    companyLogo: '',
    profileBanner: '',
    brochure: '',
    
    // Factory Details
    factoryName: '',
    factorySize: '',
    factorySizeUnit: '',
    qualityControlStaff: '',
    noOfEmployees: '',
    rdStaff: '',
    productionLines: '',
    annualOutput: '',
    leadTime: '',
    factoryAddress: '',
    factoryCountry: '',
    factoryCity: '',
    factoryState: '',
    factoryPincode: '',
    
    // Warehouse Location
    warehouseName: '',
    stockQuantity: '',
    warehouseAddress: '',
    warehouseCountry: '',
    warehouseCity: '',
    warehouseState: '',
    warehousePincode: '',
    
    // Port Data
    nearestPort: '',
    portDistance: '',
    nearestAirport: '',
    airportDistance: '',
    
    // Shipping Information
    shippingTerms: '',
    modeOfTransport: '',
    dispatchLocation: '',
    
    // Quality Control
    qualityControlProcess: '',
    
    // Certificates
    certificates: [{
      title: '',
      dateIssued: '',
      certificationCompany: '',
      expiryDate: '',
      details: '',
      attachment: ''
    }],
    
    // Certificate limit
    maxCertificates: 999,
    
    // Packaging Details
    unitsPerCarton: '',
    grossWeight: '',
    netWeight: '',
    packingType: '',
    packingMaterials: '',
    labelling: '',
    
    // Payment Methods
    paymentMethod: '',
    paymentSchedule: '',
    latePaymentPolicy: '',
    paymentCurrency: '',
    
    // Refund Policy
    refundPolicyDescription: ''
  });


  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prevState => ({
      ...prevState,
      [name]: value
    }));
  };

  const handleFileChange = (e) => {
    const { name, files } = e.target;
    if (files && files[0]) {
      setFormData(prevState => ({
        ...prevState,
        [name]: files[0].name
      }));
    }
  };

  // (Timezone picker removed; using standard select)


  const handleTabClick = (tab) => {
    setActiveTab(tab);
  };

  const handleSave = () => {
    console.log('Form Data:', formData);
    // Add API call here
  };

  const handleAddMainProduct = () => {
    const value = (formData.mainProductInput || '').trim();
    if (!value) return;
    const exists = formData.mainProducts.some(
      (p) => p.toLowerCase() === value.toLowerCase()
    );
    if (exists) return;
    setFormData({
      ...formData,
      mainProducts: [...formData.mainProducts, value],
      mainProductInput: ''
    });
  };

  const handleRemoveMainProduct = (indexToRemove) => {
    setFormData({
      ...formData,
      mainProducts: formData.mainProducts.filter((_, idx) => idx !== indexToRemove)
    });
  };

  const handleAddCertificate = () => {
    // Check if we can add more certificates
    if (formData.certificates.length >= formData.maxCertificates) {
      return; // Don't add if limit reached
    }
    
    // Add new certificate
    setFormData({
      ...formData,
      certificates: [...formData.certificates, {
        title: '',
        dateIssued: '',
        certificationCompany: '',
        expiryDate: '',
        details: '',
        attachment: ''
      }]
    });
  };

  const handleCertificateChange = (index, field, value) => {
    const updatedCertificates = [...formData.certificates];
    updatedCertificates[index] = {
      ...updatedCertificates[index],
      [field]: value
    };
    setFormData({
      ...formData,
      certificates: updatedCertificates
    });
  };

  const handleRemoveCertificate = (indexToRemove) => {
    setFormData({
      ...formData,
      certificates: formData.certificates.filter((_, idx) => idx !== indexToRemove)
    });
  };

  const handleNext = () => {
    // Handle navigation to next section
    const tabs = ['company', 'factory', 'quality', 'product', 'packaging'];
    const currentIndex = tabs.indexOf(activeTab);
    if (currentIndex < tabs.length - 1) {
      setActiveTab(tabs[currentIndex + 1]);
    }
  };

  return (
    <div className="container-fluid">
      

      <div className="row">
    
        {/* Main Content */}
        <main className="col-lg-12">
          <div className="p-4">
            {/* Main Content Card */}
            <div className="bsp-card">
              {/* Custom Navigation Tabs */}
              <div className="custom-tabs-container">
                <div className="custom-tabs-nav">
                  {tabs.map((tab) => (
                    <div
                      key={tab.key}
                      className={`custom-tab ${activeTab === tab.key ? 'active' : ''}`}
                      onClick={() => setActiveTab(tab.key)}
                    >
                      <span className="tab-icon">{tab.icon}</span>
                      <span className="tab-label">{tab.label}</span>
                </div>
                  ))}
                </div>
                <div className="custom-tabs-content">
                  {activeTab === 'company' && (
                    <div className="bsp-content-pad container-fluid">
            {/* Form Section */}
            <form>
              {/* Company Section */}
              <div className="form-section">
                          <h5 className="section-sub-title">
                            <TeamOutlined className="section-icon" />
                            Company
                          </h5>
                <div className="row g-3">
                            <div className="col-md-3">
                    <input
                      type="text"
                      placeholder="Name of the Company"
                                className="form-control"
                      name="companyName"
                      value={formData.companyName}
                      onChange={handleInputChange}
                    />
                  </div>
                            <div className="col-md-3">
                    <input
                      type="text"
                      placeholder="Designation"
                                className="form-control"
                      name="designation"
                      value={formData.designation}
                      onChange={handleInputChange}
                    />
                  </div>
                            <div className="col-md-3">
                              <select
                                className="form-control"
                      name="businessType"
                      value={formData.businessType}
                      onChange={handleInputChange}
                              >
                                <option value="">Select Business Type</option>
                                {businessTypeOptions.map((option, index) => (
                                  <option key={index} value={option}>
                                    {option}
                                  </option>
                                ))}
                              </select>
                  </div>
                            <div className="col-md-3">
                    <input
                      type="text"
                      placeholder="GST Number"
                                className="form-control"
                      name="gstNumber"
                      value={formData.gstNumber}
                      onChange={handleInputChange}
                    />
                  </div>
                            <div className="col-md-3">
                    <input
                      type="text"
                      placeholder="Registration Number"
                                className="form-control"
                      name="registrationNumber"
                      value={formData.registrationNumber}
                      onChange={handleInputChange}
                    />
                  </div>
                            <div className="col-md-3">
                    <input
                      type="text"
                      placeholder="Website"
                                className="form-control"
                      name="website"
                      value={formData.website}
                      onChange={handleInputChange}
                    />
                  </div>
                            <div className="col-md-3">
                    <input
                      type="text"
                      placeholder="No of Employees"
                                className="form-control"
                      name="noOfEmployees"
                      value={formData.noOfEmployees}
                      onChange={handleInputChange}
                    />
                  </div>
                            <div className="col-md-3">
                    <input
                      type="text"
                      placeholder="Year Established"
                                className="form-control"
                      name="yearEstablished"
                      value={formData.yearEstablished}
                      onChange={handleInputChange}
                    />
                  </div>
                  <div className="col-md-6">
                    <textarea
                                className="bsp-textarea bsp-textarea--compact form-control"
                      placeholder="Company Description"
                      name="companyDescription"
                      value={formData.companyDescription}
                      onChange={handleInputChange}
                    ></textarea>
                            
                            </div>
                            <div className="col-md-6">
                            <div className="bsp-file-upload-group">
                              <div className="row g-3">
                                <div className="col-md-4">
                                  <div className="bsp-file-upload-item">
                                    <label htmlFor="companyLogo" className="bsp-file-upload-label">Company Logo</label>
                                    <div className="bsp-file-upload-area">
                        <input 
                                        type="file" 
                          id="companyLogo" 
                                        name="companyLogo"
                                        className="bsp-file-input"
                                        accept="image/*"
                                        onChange={handleFileChange}
                                      />
                                      <div className="bsp-file-upload-content">
                                        {formData.companyLogo ? (
                                          <div className="bsp-file-selected">
                                            <div className="bsp-upload-icon">✅</div>
                                            <div className="bsp-upload-text">
                                              <span className="bsp-upload-title">File Selected</span>
                                              <span className="bsp-file-name">{formData.companyLogo}</span>
                      </div>
                                            <div className="bsp-file-types">Click to change file</div>
                                          </div>
                                        ) : (
                                          <div>
                                            <div className="bsp-upload-icon">📁</div>
                                            <div className="bsp-upload-text">
                                              <span className="bsp-upload-title">Click to upload</span>
                                              <span className="bsp-upload-subtitle">or drag and drop</span>
                                            </div>
                                            <div className="bsp-file-types">PNG, JPG, GIF up to 10MB</div>
                                          </div>
                                        )}
                                      </div>
                                    </div>
                                  </div>
                      </div>
                                <div className="col-md-4">
                                  <div className="bsp-file-upload-item">
                                    <label htmlFor="profileBanner" className="bsp-file-upload-label">Profile Banner</label>
                                    <div className="bsp-file-upload-area">
                        <input 
                                        type="file" 
                          id="profileBanner" 
                                        name="profileBanner"
                                        className="bsp-file-input"
                                        accept="image/*"
                                        onChange={handleFileChange}
                                      />
                                      <div className="bsp-file-upload-content">
                                        {formData.profileBanner ? (
                                          <div className="bsp-file-selected">
                                            <div className="bsp-upload-icon">✅</div>
                                            <div className="bsp-upload-text">
                                              <span className="bsp-upload-title">File Selected</span>
                                              <span className="bsp-file-name">{formData.profileBanner}</span>
                      </div>
                                            <div className="bsp-file-types">Click to change file</div>
                                          </div>
                                        ) : (
                                          <div>
                                            <div className="bsp-upload-icon">📁</div>
                                            <div className="bsp-upload-text">
                                              <span className="bsp-upload-title">Click to upload</span>
                                              <span className="bsp-upload-subtitle">or drag and drop</span>
                                            </div>
                                            <div className="bsp-file-types">PNG, JPG, GIF up to 10MB</div>
                                          </div>
                                        )}
                                      </div>
                                    </div>
                                  </div>
                      </div>
                                <div className="col-md-4">
                                  <div className="bsp-file-upload-item">
                                    <label htmlFor="brochure" className="bsp-file-upload-label">Brochure</label>
                                    <div className="bsp-file-upload-area">
                        <input 
                                        type="file" 
                          id="brochure" 
                                        name="brochure"
                                        className="bsp-file-input"
                                        accept=".pdf,.doc,.docx"
                                        onChange={handleFileChange}
                                      />
                                      <div className="bsp-file-upload-content">
                                        {formData.brochure ? (
                                          <div className="bsp-file-selected">
                                            <div className="bsp-upload-icon">✅</div>
                                            <div className="bsp-upload-text">
                                              <span className="bsp-upload-title">File Selected</span>
                                              <span className="bsp-file-name">{formData.brochure}</span>
                      </div>
                                            <div className="bsp-file-types">Click to change file</div>
                    </div>
                                        ) : (
                                          <div>
                                            <div className="bsp-upload-icon">📄</div>
                                            <div className="bsp-upload-text">
                                              <span className="bsp-upload-title">Click to upload</span>
                                              <span className="bsp-upload-subtitle">or drag and drop</span>
                  </div>
                                            <div className="bsp-file-types">PDF, DOC, DOCX up to 10MB</div>
                                          </div>
                                        )}
                                      </div>
                      </div>
                    </div>
                  </div>
                  </div>
                            </div>
                            </div>

                            
                </div>
              </div>

              {/* Main Products Section */}
              <div className="mb-4">
                <h5 className="section-sub-title">
                  <TagOutlined className="section-icon" />
                  Main Products
                </h5>
                <div className="d-flex align-items-center gap-3 main-products">
                  <div className="flex-grow-1">
                    <input
                      type="text"
                      className="form-control"
                      placeholder="eg. chilli powder"
                      name="mainProductInput"
                      value={formData.mainProductInput}
                      onChange={handleInputChange}
                      onKeyDown={(e) => { if (e.key === 'Enter') { e.preventDefault(); handleAddMainProduct(); } }}
                    />
                  </div>
                  <button type="button" className="bsp-btn bsp-btn-orange" onClick={handleAddMainProduct}>Add</button>
                </div>
                {formData.mainProducts && formData.mainProducts.length > 0 && (
                  <div className="bsp-tags mt-3">
                    {formData.mainProducts.map((prod, idx) => (
                      <span key={`${prod}-${idx}`} className="bsp-tag">
                        {prod}
                        <button type="button" className="bsp-tag-remove" onClick={() => handleRemoveMainProduct(idx)} aria-label="Remove">
                          ×
                        </button>
                      </span>
                    ))}
                  </div>
                )}
              </div>

              {/* Contact Details Section */}
              <div className="mb-4">
                <h5 className="section-sub-title">
                  <PhoneOutlined className="section-icon" />
                  Contact Details
                </h5>
                <div className="row g-3">
                  <div className="col-md-4">
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Alternate Contact Name"
                      name="alternateContactName"
                      value={formData.alternateContactName}
                      onChange={handleInputChange}
                    />
                  </div>
                  <div className="col-md-4">
                    <input
                      type="email"
                      className="form-control"
                      placeholder="Alternate Email"
                      name="alternateEmail"
                      value={formData.alternateEmail}
                      onChange={handleInputChange}
                    />
                  </div>
                  <div className="col-md-4">
                    <input
                      type="tel"
                      className="form-control"
                      placeholder="Alternate Contact"
                      name="alternateContact"
                      value={formData.alternateContact}
                      onChange={handleInputChange}
                    />
                  </div>
                </div>
              </div>

              {/* Address Section */}
                        <h5 className="section-sub-title">
                          <GlobalOutlined className="section-icon" />
                          Address
                        </h5>
              <div className="mb-4">
                <div className="row g-3">
                            <div className="col-md-4">
                    <input
                      type="text"
                      className="form-control"
                                placeholder="Address"
                      name="address"
                      value={formData.address}
                      onChange={handleInputChange}
                    />
                  </div>
                            <div className="col-md-4">
                    <input
                      type="text"
                      className="form-control"
                                placeholder="Landmark"
                      name="landmark"
                      value={formData.landmark}
                      onChange={handleInputChange}
                    />
                  </div>
                            <div className="col-md-4">
                              <select
                                className="form-control"
                                name="currency"
                                value={formData.currency}
                                onChange={handleInputChange}
                              >
                                <option value="">Currency</option>
                                {currencyOptions.map((option, index) => (
                                  <option key={index} value={option}>
                                    {option}
                                  </option>
                                ))}
                              </select>
                  </div>
                  <div className="col-md-3">
                    <select
                      className="form-control"
                      name="countryRegion"
                      value={formData.countryRegion}
                      onChange={handleInputChange}
                    >
                      <option value="">Country/Region</option>
                      {countryOptions.map((option, index) => (
                        <option key={index} value={option}>
                          {option}
                        </option>
                      ))}
                    </select>
                  </div>

                  <div className="col-md-3">
                    <select
                      className="form-control"
                      name="state"
                      value={formData.state}
                      onChange={handleInputChange}
                    >
                      <option value="">State</option>
                      {stateOptions.map((option, index) => (
                        <option key={index} value={option}>
                          {option}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div className="col-md-3">
                    <select
                      className="form-control"
                      name="city"
                      value={formData.city}
                      onChange={handleInputChange}
                    >
                      <option value="">City</option>
                      {cityOptions.map((option, index) => (
                        <option key={index} value={option}>
                          {option}
                        </option>
                      ))}
                    </select>
                  </div>
                  
                  <div className="col-md-3">
                    <input
                      type="text"
                      className="form-control"
                                placeholder="Pincode"
                                name="pincode"
                                value={formData.pincode}
                      onChange={handleInputChange}
                    />
                  </div>
                            
                </div>
              </div>

              {/* Bank Details Section */}
              <div className="mb-4">
                          <h5 className="section-sub-title">
                            <BankOutlined className="section-icon" />
                            Bank Details
                          </h5>
                <div className="row g-3">
                  <div className="col-md-4">
                    <input
                      type="text"
                      className="form-control"
                                placeholder="Name of the Account Holder"
                      name="accountHolder"
                      value={formData.accountHolder}
                      onChange={handleInputChange}
                    />
                  </div>
                  <div className="col-md-4">
                    <input
                      type="text"
                      className="form-control"
                                placeholder="Account Number"
                      name="accountNumber"
                      value={formData.accountNumber}
                      onChange={handleInputChange}
                    />
                  </div>
                  <div className="col-md-4">
                    <input
                      type="text"
                      className="form-control"
                                placeholder="Bank Name"
                      name="bankName"
                      value={formData.bankName}
                      onChange={handleInputChange}
                    />
                  </div>
                  <div className="col-md-4">
                    <input
                      type="text"
                      className="form-control"
                                placeholder="Branch Name"
                      name="branchName"
                      value={formData.branchName}
                      onChange={handleInputChange}
                    />
                  </div>
                  <div className="col-md-4">
                    <input
                      type="text"
                      className="form-control"
                                placeholder="IFSC Code"
                      name="ifscCode"
                      value={formData.ifscCode}
                      onChange={handleInputChange}
                    />
                  </div>
                  <div className="col-md-4">
                    <input
                      type="text"
                      className="form-control"
                                placeholder="Swift Code"
                      name="swiftCode"
                      value={formData.swiftCode}
                      onChange={handleInputChange}
                    />
                  </div>
                </div>
              </div>

              {/* Trading Information Section */}
              <div className="mb-4">
                          <h5 className="section-sub-title">
                            <DollarOutlined className="section-icon" />
                            Trading Information
                          </h5>
                <div className="row g-3">
                            <div className="col-md-3">
                    <input
                      type="text"
                      className="form-control"
                                placeholder="Total Revenue (Annual)"
                      name="totalRevenue"
                      value={formData.totalRevenue}
                      onChange={handleInputChange}
                    />
                  </div>
                            <div className="col-md-3">
                    <input
                      type="text"
                      className="form-control"
                                placeholder="Export Percentage"
                      name="exportPercentage"
                      value={formData.exportPercentage}
                      onChange={handleInputChange}
                    />
                  </div>
                            <div className="col-md-3">
                    <input
                      type="text"
                      className="form-control"
                                placeholder="Company Overseas Address"
                      name="overseasAddress"
                      value={formData.overseasAddress}
                      onChange={handleInputChange}
                    />
                  </div>
                            <div className="col-md-3">
                    <input
                      type="text"
                      className="form-control"
                                placeholder="IEC Number"
                      name="iecNumber"
                      value={formData.iecNumber}
                      onChange={handleInputChange}
                    />
                  </div>
                </div>
              </div>

              {/* Timezone Section */}
              <div className="mb-4">
                          <h5 className="section-sub-title">
                            <TimeIcon className="section-icon" />
                            Timezone
                          </h5>
                <div className="row g-3">
                  <div className="col-md-6">
                              <select
                      className="form-control"
                      name="timezone"
                      value={formData.timezone}
                      onChange={handleInputChange}
                              >
                                <option value="">Select Timezone</option>
                                <option value="UTC-12:00 (Baker Island)">UTC-12:00 (Baker Island)</option>
                                <option value="UTC-11:00 (American Samoa)">UTC-11:00 (American Samoa)</option>
                                <option value="UTC-10:00 (Hawaii)">UTC-10:00 (Hawaii)</option>
                                <option value="UTC-09:00 (Alaska)">UTC-09:00 (Alaska)</option>
                                <option value="UTC-08:00 (Pacific Time)">UTC-08:00 (Pacific Time)</option>
                                <option value="UTC-07:00 (Mountain Time)">UTC-07:00 (Mountain Time)</option>
                                <option value="UTC-06:00 (Central Time)">UTC-06:00 (Central Time)</option>
                                <option value="UTC-05:00 (Eastern Time)">UTC-05:00 (Eastern Time)</option>
                                <option value="UTC-04:00 (Atlantic Time)">UTC-04:00 (Atlantic Time)</option>
                                <option value="UTC-03:00 (Brazil)">UTC-03:00 (Brazil)</option>
                                <option value="UTC-02:00 (Mid-Atlantic)">UTC-02:00 (Mid-Atlantic)</option>
                                <option value="UTC-01:00 (Azores)">UTC-01:00 (Azores)</option>
                                <option value="UTC+00:00 (GMT)">UTC+00:00 (GMT)</option>
                                <option value="UTC+01:00 (CET)">UTC+01:00 (CET)</option>
                                <option value="UTC+02:00 (EET)">UTC+02:00 (EET)</option>
                                <option value="UTC+03:00 (MSK)">UTC+03:00 (MSK)</option>
                                <option value="UTC+04:00 (GST)">UTC+04:00 (GST)</option>
                                <option value="UTC+05:00 (PKT)">UTC+05:00 (PKT)</option>
                                <option value="UTC+05:30 (IST)">UTC+05:30 (IST)</option>
                                <option value="UTC+06:00 (BST)">UTC+06:00 (BST)</option>
                                <option value="UTC+07:00 (ICT)">UTC+07:00 (ICT)</option>
                                <option value="UTC+08:00 (CST)">UTC+08:00 (CST)</option>
                                <option value="UTC+09:00 (JST)">UTC+09:00 (JST)</option>
                                <option value="UTC+10:00 (AEST)">UTC+10:00 (AEST)</option>
                                <option value="UTC+11:00 (SBT)">UTC+11:00 (SBT)</option>
                                <option value="UTC+12:00 (NZST)">UTC+12:00 (NZST)</option>
                              </select>
                            </div>
                          </div>
                        </div>

              {/* Form Actions */}
                        <div className="d-flex justify-content-end gap-3 bsp-actions">
                <button
                  type="button"
                            className="bsp-btn bsp-btn-primary"
                  onClick={handleSave}
                >
                  Save
                </button>
                <button
                  type="button"
                            className="bsp-btn bsp-btn-secondary"
                  onClick={handleNext}
                >
                  Next
                </button>
              </div>
            </form>
                    </div>
                  )}
                  {activeTab === 'factory' && (
                    <div className="bsp-content-pad">
                      <form>
                        {/* Factory Details Section */}
                        <div className="form-section mb-4">
                          <div className="d-flex justify-content-between align-items-center mb-3">
                            <h5 className="section-sub-title">
                              <FactoryIcon className="section-icon" />
                              Factory Details
                            </h5>
                            <button type="button" className="bsp-btn bsp-btn-orange">
                              <PlusOutlined /> Add More
                            </button>
                          </div>
                          <div className="row g-3">
                            <div className="col-md-3">
                              <input
                                type="text"
                                className="form-control"
                                placeholder="Factory Name"
                                name="factoryName"
                                value={formData.factoryName}
                      onChange={handleInputChange}
                    />
                  </div>
                            <div className="col-md-3">
                              <div className="input-group">
                                <input
                                  type="text"
                                  className="form-control"
                                  placeholder="Factory Size"
                                  name="factorySize"
                                  value={formData.factorySize}
                                  onChange={handleInputChange}
                                />
                                <div className="input-group-append">
                                  <select
                                    className="form-control"
                                    name="factorySizeUnit"
                                    value={formData.factorySizeUnit}
                                    onChange={handleInputChange}
                                  >
                                     <option value="">Select Unit</option>
                                    <option value="sqft">sqft</option>
                                    <option value="sqm">sqm</option>
                                    <option value="acres">acres</option>
                                    <option value="hectares">hectares</option>
                                  </select>
                                </div>
                              </div>
                            </div>
                            <div className="col-md-3">
                              <input
                                type="text"
                                className="form-control"
                                placeholder="Total Number of Quality Control Staff"
                                name="qualityControlStaff"
                                value={formData.qualityControlStaff}
                                onChange={handleInputChange}
                              />
                            </div>
                            <div className="col-md-3">
                              <input
                                type="text"
                                className="form-control"
                                placeholder="No of Employees / Staff"
                                name="noOfEmployees"
                                value={formData.noOfEmployees}
                                onChange={handleInputChange}
                              />
                            </div>
                            <div className="col-md-3">
                              <input
                                type="text"
                                className="form-control"
                                placeholder="Total Number Research & Development Staff"
                                name="rdStaff"
                                value={formData.rdStaff}
                                onChange={handleInputChange}
                              />
                            </div>
                            <div className="col-md-3">
                              <input
                                type="text"
                                className="form-control"
                                placeholder="Total Number of Production Lines"
                                name="productionLines"
                                value={formData.productionLines}
                                onChange={handleInputChange}
                              />
                            </div>
                            <div className="col-md-3">
                              <input
                                type="text"
                                className="form-control"
                                placeholder="Annual Output"
                                name="annualOutput"
                                value={formData.annualOutput}
                                onChange={handleInputChange}
                              />
                            </div>
                            <div className="col-md-3">
                              <input
                                type="text"
                                className="form-control"
                                placeholder="Average Lead Time For Production"
                                name="leadTime"
                                value={formData.leadTime}
                                onChange={handleInputChange}
                              />
                            </div>
                            <div className="col-md-6">
                              <textarea
                                className="bsp-textarea bsp-textarea--compact bsp-textarea--factory form-control"
                                placeholder="Address"
                                name="factoryAddress"
                                value={formData.factoryAddress}
                                onChange={handleInputChange}
                              ></textarea>
                            </div>
                            <div className="col-md-6">
                              <div className="row g-3">
                                <div className="col-md-6">
                                  <select
                                    className="form-control"
                                    name="factoryCountry"
                                    value={formData.factoryCountry}
                                    onChange={handleInputChange}
                                  >
                                    <option value="">Country/Region</option>
                                    {countryOptions.map((option, index) => (
                                      <option key={index} value={option}>
                                        {option}
                                      </option>
                                    ))}
                                  </select>
                                </div>
                                <div className="col-md-6">
                                  <select
                                    className="form-control"
                                    name="factoryState"
                                    value={formData.factoryState}
                                    onChange={handleInputChange}
                                  >
                                    <option value="">State</option>
                                    {stateOptions.map((option, index) => (
                                      <option key={index} value={option}>
                                        {option}
                                      </option>
                                    ))}
                                  </select>
                                </div>
                                <div className="col-md-6">
                                  <select
                                    className="form-control"
                                    name="factoryCity"
                                    value={formData.factoryCity}
                                    onChange={handleInputChange}
                                  >
                                    <option value="">City</option>
                                    {cityOptions.map((option, index) => (
                                      <option key={index} value={option}>
                                        {option}
                                      </option>
                                    ))}
                                  </select>
                                </div>
                               
                                <div className="col-md-6">
                                  <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Pincode"
                                    name="factoryPincode"
                                    value={formData.factoryPincode}
                                    onChange={handleInputChange}
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                        {/* Warehouse Location Section */}
                        <div className="form-section mb-4">
                          <div className="d-flex justify-content-between align-items-center mb-3">
                            <h5 className="section-sub-title">
                              <WarehouseIcon className="section-icon" />
                              Warehouse Location
                            </h5>
                            <button type="button" className="bsp-btn bsp-btn-orange">
                              <PlusOutlined /> Add More
                            </button>
                          </div>
                          <div className="row g-3">
                            <div className="col-md-6">
                              <input
                                type="text"
                                className="form-control"
                                placeholder="Warehouse Name"
                                name="warehouseName"
                                value={formData.warehouseName}
                                onChange={handleInputChange}
                              />
                            </div>
                            <div className="col-md-6">
                              <input
                                type="text"
                                className="form-control"
                                placeholder="Stock Quantity"
                                name="stockQuantity"
                                value={formData.stockQuantity}
                                onChange={handleInputChange}
                              />
                            </div>
                            <div className="col-md-6">
                              <textarea
                                className="bsp-textarea bsp-textarea--compact bsp-textarea--factory form-control"
                                placeholder="Address"
                                name="warehouseAddress"
                                value={formData.warehouseAddress}
                                onChange={handleInputChange}
                              ></textarea>
                            </div>
                            <div className="col-md-6">
                              <div className="row g-3">
                                <div className="col-md-6">
                                  <select
                                    className="form-control"
                                    name="warehouseCountry"
                                    value={formData.warehouseCountry}
                                    onChange={handleInputChange}
                                  >
                                    <option value="">Country/Region</option>
                                    {countryOptions.map((option, index) => (
                                      <option key={index} value={option}>
                                        {option}
                                      </option>
                                    ))}
                                  </select>
                                </div>
                                <div className="col-md-6">
                                  <select
                                    className="form-control"
                                    name="warehouseState"
                                    value={formData.warehouseState}
                                    onChange={handleInputChange}
                                  >
                                    <option value="">State</option>
                                    {stateOptions.map((option, index) => (
                                      <option key={index} value={option}>
                                        {option}
                                      </option>
                                    ))}
                                  </select>
                                </div>
                                <div className="col-md-6">
                                  <select
                                    className="form-control"
                                    name="warehouseCity"
                                    value={formData.warehouseCity}
                                    onChange={handleInputChange}
                                  >
                                    <option value="">City</option>
                                    {cityOptions.map((option, index) => (
                                      <option key={index} value={option}>
                                        {option}
                                      </option>
                                    ))}
                                  </select>
                                </div>
                                
                                <div className="col-md-6">
                                  <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Pincode"
                                    name="warehousePincode"
                                    value={formData.warehousePincode}
                                    onChange={handleInputChange}
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                         {/* Port Data Section */}
                         <div className="form-section mb-4">
                           <h5 className="section-sub-title">
                             <CarOutlined className="section-icon" />
                             Port Data
                           </h5>
                          <div className="row g-3">
                            <div className="col-md-3">
                              <input
                                type="text"
                                className="form-control"
                                placeholder="Factory's nearest port"
                                name="nearestPort"
                                value={formData.nearestPort}
                                onChange={handleInputChange}
                              />
                            </div>
                            <div className="col-md-3">
                              <input
                                type="text"
                                className="form-control"
                                placeholder="The factory-to-port distance"
                                name="portDistance"
                                value={formData.portDistance}
                                onChange={handleInputChange}
                              />
                            </div>
                            <div className="col-md-3">
                              <input
                                type="text"
                                className="form-control"
                                placeholder="The nearest Air port"
                                name="nearestAirport"
                                value={formData.nearestAirport}
                                onChange={handleInputChange}
                              />
                            </div>
                            <div className="col-md-3">
                              <input
                                type="text"
                                className="form-control"
                                placeholder="The Factory-to-Airport distance"
                                name="airportDistance"
                                value={formData.airportDistance}
                                onChange={handleInputChange}
                              />
                            </div>
                          </div>
                        </div>

                        {/* Shipping Information Section */}
                        <div className="form-section mb-4">
                          <h5 className="section-sub-title">
                            <TruckOutlined className="section-icon" />
                            Shipping information
                          </h5>
                          <div className="row g-3">
                            <div className="col-md-4">
                              <select
                                className="form-control"
                                name="shippingTerms"
                                value={formData.shippingTerms}
                                onChange={handleInputChange}
                              >
                                <option value="">Shipping Terms</option>
                                {shippingTermsOptions.map((option, index) => (
                                  <option key={index} value={option}>
                                    {option}
                                  </option>
                                ))}
                              </select>
                            </div>
                            <div className="col-md-4">
                              <select
                                className="form-control"
                                name="modeOfTransport"
                                value={formData.modeOfTransport}
                                onChange={handleInputChange}
                              >
                                <option value="">Mode of Transport</option>
                                {transportModeOptions.map((option, index) => (
                                  <option key={index} value={option}>
                                    {option}
                                  </option>
                                ))}
                              </select>
                            </div>
                            <div className="col-md-4">
                              <select
                                className="form-control"
                                name="dispatchLocation"
                                value={formData.dispatchLocation}
                                onChange={handleInputChange}
                              >
                                <option value="">Dispatch Location</option>
                                <option value="Factory">Factory</option>
                                <option value="Warehouse">Warehouse</option>
                                <option value="Port">Port</option>
                                <option value="Airport">Airport</option>
                              </select>
                  </div>
                </div>
              </div>

              {/* Form Actions */}
                        <div className="d-flex justify-content-between gap-3 bsp-actions">
                <button
                  type="button"
                            className="bsp-btn bsp-btn-secondary"
                            onClick={() => setActiveTab('company')}
                          >
                            Back
                          </button>
                          <div className="d-flex gap-3">
                            <button
                              type="button"
                              className="bsp-btn bsp-btn-orange"
                  onClick={handleSave}
                >
                  Save
                </button>
                <button
                  type="button"
                              className="bsp-btn bsp-btn-secondary"
                  onClick={handleNext}
                >
                  Next
                </button>
                          </div>
              </div>
            </form>
                    </div>
                  )}
                  {activeTab === 'quality' && (
                    <div className="bsp-content-pad">
                      <form>
                        {/* Quality Control Section */}
                        <div className="form-section mb-4">
                          <h5 className="section-sub-title">
                            <SafetyCertificateOutlined className="section-icon" />
                            Quality Control
                          </h5>
                          <div className="row g-3">
                            <div className="col-md-12">
                              <textarea
                                className="bsp-textarea bsp-textarea--compact form-control"
                                placeholder="Please describe your organization's quality control process."
                                name="qualityControlProcess"
                                value={formData.qualityControlProcess}
                                onChange={handleInputChange}
                              ></textarea>
                            </div>
                          </div>
                        </div>

                         {/* Certificates Section */}
                         <div className="form-section mb-4">
                           <div className="d-flex justify-content-between align-items-center mb-3">
                             <h5 className="section-sub-title">
                               <CertificateIcon className="section-icon" />
                               Certificates
                             </h5>
                             <button 
                               type="button" 
                               className="bsp-btn bsp-btn-orange"
                               onClick={handleAddCertificate}
                             >
                               <PlusOutlined /> Add More
                             </button>
                           </div>
                          
                           {formData.certificates.map((certificate, index) => (
                             <div key={index} className=" mb-4">
                               <div className="d-flex justify-content-between align-items-center mb-3">
                                 {/* <h6 className="mb-0">Certificate {index + 1}</h6> */}
                                 {formData.certificates.length > 1 && (
                                   <button
                                     type="button"
                                     className="btn btn-sm btn-outline-danger"
                                     onClick={() => handleRemoveCertificate(index)}
                                   >
                                     Remove
                                   </button>
                                 )}
                               </div>
                               
                               <div className="row g-3">
                                <div className="col-md-3">
                                  <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Title"
                                    value={certificate.title}
                                    onChange={(e) => handleCertificateChange(index, 'title', e.target.value)}
                                  />
                                </div>
                                <div className="col-md-3">
                                  <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Certification Company"
                                    value={certificate.certificationCompany}
                                    onChange={(e) => handleCertificateChange(index, 'certificationCompany', e.target.value)}
                                  />
                                </div>
                                <div className="col-md-3">
                                  <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Date Issued "
                                    value={certificate.dateIssued}
                                    onChange={(e) => handleCertificateChange(index, 'dateIssued', e.target.value)}
                                  />
                                </div>
                                
                                <div className="col-md-3">
                                  <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Expiry Date"
                                    value={certificate.expiryDate}
                                    onChange={(e) => handleCertificateChange(index, 'expiryDate', e.target.value)}
                                  />
                                </div>
                                <div className="col-md-12">
                                  <textarea
                                    className="bsp-textarea bsp-textarea--compact form-control"
                                    placeholder="Enter Details about Certificate"
                                    value={certificate.details}
                                    onChange={(e) => handleCertificateChange(index, 'details', e.target.value)}
                                  ></textarea>
                                </div>
                                <div className="col-md-12">
                                  <div className="file-upload-section">
                                    <label htmlFor={`certificate-attachment-${index}`} className="file-upload-label">
                                      <UploadOutlined className="me-2" />
                                      Attachment (jpg, jpeg and png formats are supported)
                                    </label>
                                    <input
                                      type="file"
                                      id={`certificate-attachment-${index}`}
                                      className="form-control"
                                      accept=".jpg,.jpeg,.png"
                                      onChange={(e) => {
                                        const file = e.target.files[0];
                                        if (file) {
                                          handleCertificateChange(index, 'attachment', file.name);
                                        }
                                      }}
                                    />
                                    {certificate.attachment && (
                                      <div className="mt-2 text-muted">
                                        Selected: {certificate.attachment}
                                      </div>
                                    )}
                                  </div>
                                 </div>
                               </div>
                             </div>
                           ))}
                        </div>

                        {/* Form Actions */}
                        <div className="d-flex justify-content-between gap-3 bsp-actions">
                          <button
                            type="button"
                            className="bsp-btn bsp-btn-secondary"
                            onClick={() => setActiveTab('factory')}
                          >
                            Back
                          </button>
                          <div className="d-flex gap-3">
                            <button
                              type="button"
                              className="bsp-btn bsp-btn-orange"
                              onClick={handleSave}
                            >
                              Save
                            </button>
                            <button
                              type="button"
                              className="bsp-btn bsp-btn-secondary"
                              onClick={handleNext}
                            >
                              Next
                            </button>
                          </div>
                        </div>
                      </form>
                    </div>
                  )}
                  {activeTab === 'product' && (
                    <div className="bsp-content-pad">
                      {/* Product catalogue form content */}
                    </div>
                  )}
                   {activeTab === 'packaging' && (
                     <div className="bsp-content-pad">
                       <form>
                         {/* Packaging Details Section */}
                         <div className="form-section mb-4">
                           <h5 className="section-sub-title">
                             <PackagingIcon className="section-icon" />
                             Packaging Details
                           </h5>
                           <div className="row g-3">
                             <div className="col-md-4">
                               <input
                                 type="text"
                                 className="form-control"
                                 placeholder="Units Per Carton"
                                 name="unitsPerCarton"
                                 value={formData.unitsPerCarton}
                                 onChange={handleInputChange}
                               />
                             </div>
                             <div className="col-md-4">
                               <input
                                 type="text"
                                 className="form-control"
                                 placeholder="Gross Weight"
                                 name="grossWeight"
                                 value={formData.grossWeight}
                                 onChange={handleInputChange}
                               />
                             </div>
                             <div className="col-md-4">
                               <input
                                 type="text"
                                 className="form-control"
                                 placeholder="Net Weight"
                                 name="netWeight"
                                 value={formData.netWeight}
                                 onChange={handleInputChange}
                               />
                             </div>
                             <div className="col-md-4">
                               <select
                                 className="form-control"
                                 name="packingType"
                                 value={formData.packingType}
                                 onChange={handleInputChange}
                               >
                                 <option value="">Packing Type</option>
                                 {packingTypeOptions.map((option, index) => (
                                   <option key={index} value={option}>
                                     {option}
                                   </option>
                                 ))}
                               </select>
                             </div>
                             <div className="col-md-4">
                               <select
                                 className="form-control"
                                 name="packingMaterials"
                                 value={formData.packingMaterials}
                                 onChange={handleInputChange}
                               >
                                 <option value="">Packing Materials</option>
                                 {packingMaterialsOptions.map((option, index) => (
                                   <option key={index} value={option}>
                                     {option}
                                   </option>
                                 ))}
                               </select>
                             </div>
                             <div className="col-md-4">
                               <select
                                 className="form-control"
                                 name="labelling"
                                 value={formData.labelling}
                                 onChange={handleInputChange}
                               >
                                 <option value="">Labelling</option>
                                 {labellingOptions.map((option, index) => (
                                   <option key={index} value={option}>
                                     {option}
                                   </option>
                                 ))}
                               </select>
                             </div>
                           </div>
                         </div>

                         {/* Accepted Payment Methods Section */}
                         <div className="form-section mb-4">
                           <h5 className="section-sub-title">
                             <PaymentIcon className="section-icon" />
                             Accepted Payment Methods
                           </h5>
                           <div className="row g-3">
                             <div className="col-md-6">
                               <select
                                 className="form-control"
                                 name="paymentMethod"
                                 value={formData.paymentMethod}
                                 onChange={handleInputChange}
                               >
                                 <option value="">Payment Method</option>
                                 {paymentMethodOptions.map((option, index) => (
                                   <option key={index} value={option}>
                                     {option}
                                   </option>
                                 ))}
                               </select>
                             </div>
                             <div className="col-md-6">
                               <select
                                 className="form-control"
                                 name="paymentSchedule"
                                 value={formData.paymentSchedule}
                                 onChange={handleInputChange}
                               >
                                 <option value="">Payment Schedule</option>
                                 {paymentScheduleOptions.map((option, index) => (
                                   <option key={index} value={option}>
                                     {option}
                                   </option>
                                 ))}
                               </select>
                             </div>
                             <div className="col-md-6">
                               <select
                                 className="form-control"
                                 name="latePaymentPolicy"
                                 value={formData.latePaymentPolicy}
                                 onChange={handleInputChange}
                               >
                                 <option value="">Late Payment Policy</option>
                                 {latePaymentPolicyOptions.map((option, index) => (
                                   <option key={index} value={option}>
                                     {option}
                                   </option>
                                 ))}
                               </select>
                             </div>
                             <div className="col-md-6">
                               <select
                                 className="form-control"
                                 name="paymentCurrency"
                                 value={formData.paymentCurrency}
                                 onChange={handleInputChange}
                               >
                                 <option value="">Currency</option>
                                 {currencyOptions.map((option, index) => (
                                   <option key={index} value={option}>
                                     {option}
                                   </option>
                                 ))}
                               </select>
                             </div>
                           </div>
                         </div>

                         {/* Refund Policy Section */}
                         <div className="form-section mb-4">
                           <h5 className="section-sub-title">
                             <RefundIcon className="section-icon" />
                             Refund Policy
                           </h5>
                           <div className="row g-3">
                             <div className="col-md-12">
                               <textarea
                                 className="bsp-textarea bsp-textarea--compact form-control"
                                 placeholder="Refund Policy Description"
                                 name="refundPolicyDescription"
                                 value={formData.refundPolicyDescription}
                                 onChange={handleInputChange}
                               ></textarea>
                             </div>
                           </div>
                         </div>

                         {/* Form Actions */}
                         <div className="d-flex justify-content-between gap-3 bsp-actions">
                           <button
                             type="button"
                             className="bsp-btn bsp-btn-secondary"
                             onClick={() => setActiveTab('quality')}
                           >
                             Back
                           </button>
                           <div className="d-flex gap-3">
                             <button
                               type="button"
                               className="bsp-btn bsp-btn-orange"
                               onClick={handleSave}
                             >
                               Save
                             </button>
                             <button
                               type="button"
                               className="bsp-btn bsp-btn-orange"
                               onClick={handleSave}
                             >
                               Submit
                             </button>
                           </div>
                         </div>
                       </form>
                     </div>
                   )}
                </div>
              </div>


            </div>
          </div>
        </main>
      </div>
    </div>
  );
};

export default BuyerSellerProfile;
